<template>
  <div class="socialposts">
    <h2 class="socialposts-title">
      {{ title }}
      <a
        class="link-more is-alternative"
        :href="facebookPageUrl"
        target="_blank"
      >{{ i18n.moreSocialPosts }}</a>
    </h2>

    <kf-loader v-if="isLoading" />

    <p
      v-if="errorLoading"
      class="text-2xl text-danger text-center"
    >
      {{ i18n.errorLoadingMessage }}
    </p>

    <kf-carousel
      v-if="!isLoading && !errorLoading"
      :carousel-slides="socialMediaPosts.slice(0, 3)"
      :carousel-per-view="1"
      :carousel-show-arrows="true"
      :carousel-show-bullets="true"
    />
  </div>
</template>

<script>
import KfLoader from '@/components/loader/Loader';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'LatestSocialPosts',
  components: {
    KfCarousel: () => import(/* webpackChunkName: "main" */ '@/components/carousel/Carousel.vue'),
    KfLoader,
  },
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    facebookPageUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      socialMediaPosts: [],
      isLoading: false,
      errorLoading: false,
    };
  },
  mounted() {
    this.retrieveSocialMediaPosts();
  },
  methods: {
    async retrieveSocialMediaPosts() {
      try {
        this.isLoading = true;
        const response = await axios.get('/umbraco/api/social/feed');
        this.socialMediaPosts = response.data.map((p) => {
          p.creationTime = moment(p.creationTime).format('DD-MM-YYYY');
          return p;
        });
      } catch {
        this.errorLoading = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="postcss">
.socialposts {
  @apply relative;
  min-height: 250px;

  &-title {
    @apply flex justify-between items-baseline;

    .link-more {
      @apply text-base font-normal;
    }
  }

  .carousel {
    @apply relative ml-0 border border-gray-500 rounded overflow-hidden pb-4;

    .glide {
      &__track {
        @apply pl-0;
      }

      &__slides {
        @apply pb-0;

        .glide__slide {
          @apply h-full;
        }
      }
    }

    &-card {
      @apply shadow-none;

      &-img {
        @apply w-full h-full object-cover;

        &-container {
          height: 180px;
        }
      }

      &-content {
        @apply text-sm mb-0;

        &-container {
          @apply p-4;
        }
      }
    }

    // arrows container
    div[data-glide-el=controls] {
      .glide__arrow {

        &--left {
          left: 4px;
        }

        &--right {
          right: 4px;
        }
      }
    }

    // Bullets
    .glide__bullets {
      @apply absolute;
      bottom: 4px;
      left: 50%;
      transform: translateX(-50%);

      .glide__bullet {
        @apply bg-primary-bravo w-3 h-3 p-0 rounded border-b-2 border-transparent cursor-pointer mx-1 my-0;
        transition: all 300ms ease-in-out;
        line-height: 0;
        box-shadow: 0 0.25em 0.5em 0 rgba(0, 0, 0, 0.1);

        &:focus {
          @apply outline-none;
        }

        &:hover,
        &:focus {
          @apply border-secondary-alpha;
        }

        &--active {
          @apply bg-secondary-alpha;
        }
      }
    }

  }
}
</style>
